// ─── ACTIONS ─────────────────────────────────────────────────────────────────

import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  openConfirmToggle,
  openFormModal,
  openViewModal,
} from "../../../store/reducers/frasesConfirmacion/Frasesconfirmacionplantel.reducer";
import { getFraseConfirmacionPlantelByIdThunk } from "../../../store/reducers/frasesConfirmacion/Frasesconfirmacionplantel.thunks";

export const FraseConfirmacionPlantelActions = ({ frase }) => {
  const dispatch = useDispatch();

  const handleEdit = async () => {
    await dispatch(getFraseConfirmacionPlantelByIdThunk(frase.id));
    dispatch(openFormModal({ mode: "edit" }));
  };

  const handleToggle = () => {
    dispatch(openConfirmToggle({ id: frase.id }));
  };

  const handleView = () => {
    dispatch(openViewModal());
    dispatch(getFraseConfirmacionPlantelByIdThunk(frase.id));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>
        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>
        <li>
          <button
            className={`${itemClass} ${frase.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                frase.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{frase.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

// ─── ROW ─────────────────────────────────────────────────────────────────────

export const FraseConfirmacionPlantelRow = ({ frase, search }) => {
  const highlightText = (text) => {
    if (!search || search.length < 3) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, "<mark>$1</mark>");
  };

  return (
    <tr>
      <td>{frase.id}</td>
      <td
        dangerouslySetInnerHTML={{
          __html: highlightText(frase.frase || "-"),
        }}
      />
      <td>{frase.orden || "-"}</td>
      <td>{frase.pregunta_texto || "-"}</td>
      <td>{frase.talento_nombre || "-"}</td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            frase.is_active
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {frase.is_active ? "Activa" : "Inactiva"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <FraseConfirmacionPlantelActions frase={frase} />
        </span>
      </td>
    </tr>
  );
};

// ─── TABLE ────────────────────────────────────────────────────────────────────

const FrasesConfirmacionPlantelTable = ({ frases, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Frase</th>
            <th>Orden</th>
            <th>Pregunta</th>
            <th>Talento</th>
            <th>Estado</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {frases.map((frase) => (
            <FraseConfirmacionPlantelRow
              key={frase.id}
              frase={frase}
              search={search}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FrasesConfirmacionPlantelTable;
